export const DOMAIN_ROUTER_TRANSPORTS = {
  domainAcademicsApi: {
    queryField: 'domainAcademicsQuery',
    mutationField: 'domainAcademicsMutation',
  },
  domainAdmissionsApi: {
    queryField: 'domainAdmissionsQuery',
    mutationField: 'domainAdmissionsMutation',
  },
  domainFinancialAidApi: {
    queryField: 'domainFinancialAidQuery',
    mutationField: 'domainFinancialAidMutation',
  },
  domainSettingsApi: {
    queryField: 'domainSettingsQuery',
    mutationField: 'domainSettingsMutation',
  },
  identityGovernanceApi: {
    queryField: 'identityGovernanceQuery',
    mutationField: 'identityGovernanceMutation',
  },
  domainPaymentsApi: {
    queryField: 'domainPaymentsQuery',
    mutationField: 'domainPaymentsMutation',
    subscriptionField: 'domainPaymentsSubscription',
  },
  domainFacultyApi: {
    queryField: 'domainFacultyQuery',
    mutationField: 'domainFacultyMutation',
  },
  domainMessagingApi: {
    queryField: 'domainMessagingQuery',
    mutationField: 'domainMessagingMutation',
  },
  domainNotificationsApi: {
    queryField: 'domainNotificationsQuery',
    mutationField: 'domainNotificationsMutation',
  },
  assistantPlatformContractApi: {
    queryField: 'assistantPlatformQuery',
    mutationField: 'assistantPlatformMutation',
  },
  assistantIntegrationsApi: {
    queryField: 'assistantIntegrationsQuery',
    mutationField: 'assistantIntegrationsMutation',
  },
  domainStudentsFamiliesApi: {
    queryField: 'domainStudentsFamiliesQuery',
    mutationField: 'domainStudentsFamiliesMutation',
  },
  parentPortalRouter: {
    queryField: 'domainParentPortalQuery',
    mutationField: 'domainParentPortalMutation',
  },
  domainDonationsApi: {
    queryField: 'domainDonationsQuery',
    mutationField: 'domainDonationsMutation',
  },
  domainCampsApi: {
    queryField: 'domainCampsQuery',
    mutationField: 'domainCampsMutation',
  },
  domainAttendanceApi: {
    queryField: 'domainAttendanceQuery',
    mutationField: 'domainAttendanceMutation',
  },
  domainSubstitutesApi: {
    queryField: 'domainSubstitutesQuery',
    mutationField: 'domainSubstitutesMutation',
  },
  domainPayrollApi: {
    queryField: 'domainPayrollQuery',
    mutationField: 'domainPayrollMutation',
  },
  domainTipATeacherApi: {
    queryField: 'domainTipATeacherQuery',
    mutationField: 'domainTipATeacherMutation',
  },
} as const;

export type DomainRouterTransportRouterName = keyof typeof DOMAIN_ROUTER_TRANSPORTS;

export type DomainRouterTransportConfig<Name extends DomainRouterTransportRouterName> =
  (typeof DOMAIN_ROUTER_TRANSPORTS)[Name];

export type DomainRouterTransportRequest<TInput = unknown> = {
  operationId: string;
  input: TInput;
};

export type DomainRouterTransportSerializedInput = string;

export type DomainRouterSerializedTransportRequest = DomainRouterTransportRequest<
  DomainRouterTransportSerializedInput
>;

export type DomainRouterTransportEnvelope<TPayload = unknown> = {
  operationId: string;
  payload: TPayload;
};

export type DomainRouterJsonInput = string | Record<string, unknown> | null | undefined;

export type DomainRouterConnection<TItem> = {
  items: TItem[];
  totalCount: number;
  nextToken?: string | null;
};

const domainRouterTransportSanitizer = (_key: string, candidate: unknown): unknown => {
  if (typeof candidate === 'bigint') {
    return candidate.toString();
  }
  if (typeof candidate === 'number' && !Number.isFinite(candidate)) {
    return null;
  }
  if (typeof candidate === 'function' || typeof candidate === 'symbol') {
    return undefined;
  }
  return candidate;
};

export const serializeDomainRouterTransportInput = (
  input: unknown
): DomainRouterTransportSerializedInput => {
  const serialized = JSON.stringify(input ?? {}, domainRouterTransportSanitizer);
  return typeof serialized === 'string' ? serialized : '{}';
};
